import React, { useState, useEffect, useRef } from "react";
import { Form, Select, DatePicker, Button } from "antd";
import Chart from "chart.js/auto";
import { useDispatch, useSelector } from "react-redux";
import { getStates } from "../features/statecity/statecitySlice";
import { getClusters } from "../features/cluster/clusterSlice";
import { getViewInvoice } from "../features/payments/paymentSlice";

const Invoice = () => {
  const chartInstanceRef = useRef(null);
  const dispatch = useDispatch();
  const [selectedState, setSelectedState] = useState("");
  const [selectedCluster, setSelectedCluster] = useState("");
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [form] = Form.useForm();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    dispatch(getStates());
    dispatch(getClusters());
    // Load initial data
    dispatch(getViewInvoice("")).then((result) => {
      if (result.payload) {
        console.log("Initial Data from API:", result.payload);
        setFilteredData(result.payload);
      } else {
        console.log("No initial data:", result);
        setFilteredData([]);
      }
    });
  }, [dispatch]);

  const statelistState = useSelector(
    (state) => state.statecity.statelist || []
  );
  const clusterlistState = useSelector((state) => state.cluster.cluster || []);

  const handleSubmit = (values) => {
    console.log("Filter Values Submitted:", values);

    const filters = {
      state_code: values.state || "",
      cluster: values.cluster || "", // Assuming cluster maps to _id in API
      start_date: values.start_date
        ? values.start_date.format("YYYY-MM-DD")
        : "",
      end_date: values.end_date ? values.end_date.format("YYYY-MM-DD") : "",
    };

    const query = Object.entries(filters)
      .filter(([_, value]) => value) // Only include non-empty values
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&");

    console.log("Query Sent to API:", query);

    dispatch(getViewInvoice(query)).then((result) => {
      if (result.payload) {
        console.log("Raw API Response:", result.payload);
        // Fallback client-side filtering to ensure correctness
        const filtered = result.payload.filter((item) => {
          const matchesState = !values.state || item.state === values.state;
          const matchesCluster =
            !values.cluster || item.cluster === values.cluster; // Adjust if cluster field differs
          const matchesStartDate =
            !values.start_date ||
            new Date(item.invoice_date) >= new Date(values.start_date);
          const matchesEndDate = "-";
          // !values.end_date || item.invoice_date <= values.end_date;
          return (
            matchesState && matchesCluster && matchesStartDate && matchesEndDate
          );
        });
        console.log("Filtered Data After Client-Side Check:", filtered);
        setFilteredData(filtered);
      } else {
        console.log("API returned no data or error:", result);
        setFilteredData([]);
      }
    });
  };

  const resetFilters = () => {
    form.resetFields();
    setSelectedState("");
    setSelectedCluster("");
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    dispatch(getViewInvoice("")).then((result) => {
      if (result.payload) {
        console.log("Reset Data from API:", result.payload);
        setFilteredData(result.payload);
      } else {
        setFilteredData([]);
      }
    });
  };

  // Chart rendering
  useEffect(() => {
    if (chartInstanceRef.current) {
      const ctx = chartInstanceRef.current.getContext("2d");

      if (chartInstanceRef.current.chart) {
        chartInstanceRef.current.chart.destroy();
      }

      if (filteredData?.length > 0) {
        console.log(filteredData, "filter data");

        const chartInstance = new Chart(ctx, {
          type: "bar",
          data: {
            // labels: filteredData?.map(
            //   (data) => data?.userData[0]?.name || "Unknown"
            // ),
            // datasets: [
            //   {
            //     label: "Deviation (days)",
            //     data: filteredData?.map((data) => {
            //       const submitted = new Date(data.invoice_date);
            //       return Math.round(submitted / (1000 * 60 * 60 * 24)) || 0;
            //     }),
            //     backgroundColor: function (context) {
            //       const value = context.raw;
            //       return value > 2 ? "red" : "green";
            //     },
            //   },
            // ],
          },
          options: {
            responsive: true,
            plugins: { legend: { position: "top" } },
            scales: {
              y: { beginAtZero: true, title: { display: true, text: "Days" } },
              x: { title: { display: true, text: "Users" } },
            },
          },
        });
        chartInstanceRef.current.chart = chartInstance;
      } else {
        console.log("No filtered data to render in chart");
      }
    }
  }, [filteredData]);

  // Pagination logic
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

  const paginatedData = filteredData.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
  const totalPages = Math.ceil(filteredData.length / pageSize);

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h4
          style={{
            textAlign: "left",
            fontWeight: "bold",
            fontSize: "large",
            marginBottom: "0.5rem",
          }}
        >
          Invoice Raised vs Submitted Overview
        </h4>
        <p
          style={{
            color: "#6b7280",
            fontSize: "0.875rem",
            textAlign: "right",
          }}
        >
          Last Updated: 10:30 AM
        </p>
      </div>

      <Form
        form={form}
        layout="inline"
        onFinish={handleSubmit}
        style={{ marginTop: "20px", marginLeft: "70px", gap: "10px" }}
      >
        <Form.Item name="state">
          <Select
            placeholder="Select State"
            onChange={(value) => setSelectedState(value)}
            value={selectedState}
            style={{ width: 150 }}
          >
            {statelistState.map((state) => (
              <Select.Option key={state.code} value={state.code}>
                {state.state_name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="cluster">
          <Select
            placeholder="Select Cluster"
            style={{ width: 150 }}
            onChange={(value) => setSelectedCluster(value)}
          >
            {clusterlistState.map((cluster) => (
              <Select.Option key={cluster._id} value={cluster._id}>
                {cluster.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="start_date">
          <DatePicker
            placeholder="From"
            style={{ width: 100 }}
            onChange={(value) => {
              setSelectedStartDate(value ? value.format("YYYY-MM-DD") : null);
            }}
          />
        </Form.Item>
        <Form.Item name="end_date">
          <DatePicker
            placeholder="To"
            style={{ width: 100 }}
            onChange={(value) => {
              setSelectedEndDate(value ? value.format("YYYY-MM-DD") : null);
            }}
          />
        </Form.Item>
        <Form.Item>
          <Button
            style={{
              backgroundColor: "#28a745",
              color: "#fff",
              marginTop: 16,
              marginLeft: 330,
            }}
            htmlType="submit"
          >
            Apply Filter
          </Button>
        </Form.Item>
        <Form.Item>
          <Button
            style={{
              backgroundColor: "#dc3545",
              color: "#fff",
              marginTop: 16,
              marginLeft: -12,
            }}
            onClick={resetFilters}
          >
            Reset Filter
          </Button>
        </Form.Item>
      </Form>

      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "0.5rem",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          padding: "1rem",
          marginTop: "1.5rem",
        }}
      >
        <canvas ref={chartInstanceRef} height="100"></canvas>
      </div>

      <div
        className="table-container"
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "0.5rem",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          padding: "1rem",
          marginTop: "1.5rem",
        }}
      >
        <div
          style={{
            marginBottom: "10px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            Showing {paginatedData.length} of {filteredData.length} entries
          </div>
          <div>
            <Select
              value={pageSize}
              onChange={handlePageSizeChange}
              style={{ width: 100 }}
            >
              <Select.Option value={10}>10</Select.Option>
              <Select.Option value={20}>20</Select.Option>
              <Select.Option value={50}>50</Select.Option>
              <Select.Option value={100}>100</Select.Option>
            </Select>
          </div>
        </div>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ backgroundColor: "#e5e7eb" }}>
            <tr>
              <th style={{ padding: "0.5rem", textAlign: "center" }}>State</th>
              <th style={{ padding: "0.5rem", textAlign: "center" }}>
                Cluster
              </th>
              <th style={{ padding: "0.5rem", textAlign: "center" }}>
                Invoice Received
              </th>
              <th style={{ padding: "0.5rem", textAlign: "center" }}>
                Invoice Submitted
              </th>
              <th style={{ padding: "0.5rem", textAlign: "center" }}>
                Deviation (days)
              </th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((data, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#f9fafb" : "#ffffff",
                }}
              >
                <td style={{ padding: "0.5rem", textAlign: "center" }}>
                  {data.state}
                </td>
                <td style={{ padding: "0.5rem", textAlign: "center" }}>
                  {data?.stateClusterData?.name || "N/A"}
                </td>
                <td style={{ padding: "0.5rem", textAlign: "center" }}>
                  {new Date(data.invoice_date).toLocaleDateString()}
                </td>
                <td style={{ padding: "0.5rem", textAlign: "center" }}>
                  {data?.submitted_date}
                </td>
                <td style={{ padding: "0.5rem", textAlign: "center" }}>
                  {Math.floor(
                    (new Date(data?.invoice_date) -
                      new Date(data?.invoice_date)) /
                      (1000 * 60 * 60 * 24) || 0
                  )}
                  days
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{ marginTop: "10px", textAlign: "center" }}>
          <Button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            style={{ marginRight: "10px" }}
          >
            Previous
          </Button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <Button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            style={{ marginLeft: "10px" }}
          >
            Next
          </Button>
        </div>
      </div>

      <div style={{ marginTop: "20px", display: "flex", gap: "15px" }}>
        <button
          style={{
            padding: "8px 12px",
            color: "#fff",
            border: "none",
            cursor: "pointer",
            backgroundColor: "#3B82F6",
            borderRadius: "5px",
          }}
        >
          Export as PDF
        </button>
        <button
          style={{
            padding: "8px 12px",
            color: "#fff",
            border: "none",
            cursor: "pointer",
            backgroundColor: "#3B82F6",
            borderRadius: "5px",
          }}
        >
          Export as CSV
        </button>
      </div>
    </div>
  );
};

export default Invoice;
